<template>
    <div>
        <LoadingScreen v-if="isLoadingScreen"></LoadingScreen>
        <div v-else class="loto__container">
            <div @click="$router.push('/')" class="loto__back">
                <img src="~ThemePath/images/chevron-left-green.png" />
                <div class="loto__back__title">
                    {{ getTranslatedText('Home') }}
                </div>
            </div>
            <div class="loto__logo">
                <img src="~ThemePath/images/logo.png" />
            </div>
            <div class="loto__items__container">
                <div class="loto__items__item" v-for="(v, i) in dataSource" :key="i">
                    <div class="loto__items__item__title">
                        {{ getTranslatedText(`loto ${v.title}`) }}
                    </div>
                    <div class="loto__box__container">
                        <div class="loto__item__box g590" v-for="(value, index) in v.listRanDomNumber" :key="index"
                            @click="onClickGames(v, value)">
                            <span>
                                {{ getTranslatedText(`${value.title}`) }} <br />
                                <span v-show="value.isShowNumber">{{ getTranslatedText(`${value.number}`) }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoadingScreen from '@/components/common/loading/index.vue'
import languageMixins from '@/mixins/language/language-mixins'
import GamesService from '@/services/games.service'

export default {
    mixins: [languageMixins],
    components: { LoadingScreen },
    data() {
        return {
            dataSource: [],
            isLoadingScreen: true,
        }
    },
    computed: {
        freebetActive() {
            return !!this.$store.state.freebetContext
        },
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            try {
                const resp = await GamesService.getListGames('multi-lotto')
                if (resp.code === 200) {
                    let listGames = resp.data.reduce(function (r, a) {
                        let name = a.game.config.grouping
                        r[name] = r[name] || []
                        r[name].push(a)
                        return r
                    }, Object.create(null))
                    let maxiumBallsSorted = 5
                    let minimumBallsSorted = 0
                    //const dataSourceOrder = ['turbo', 'nap', 'chance', 'extra']
                    const dataSourceOrder = [...new Set(resp.data.map(item => item.game.config.grouping))]
                    let dataSource = []
                    Object.keys(listGames).map((x) => {
                        let itemGame = listGames[x]
                        if (!dataSourceOrder.includes(itemGame[0].game.config.grouping)) {
                            return false
                        }
                        minimumBallsSorted = maxiumBallsSorted - listGames[x].length + 1
                        let name = itemGame[0].game.slug.substr(0, itemGame[0].game.slug.length - 1)
                        let allowedPicks = itemGame[0].game.config.allowed_picks
                        let betOptions = itemGame[0].game.config.bet_options
                        let listRanDomNumber = Array.from(Array(maxiumBallsSorted - minimumBallsSorted + 1), (_, i) => {
                            return {
                                number: allowedPicks ? itemGame[i].game.name.slice(-1) : minimumBallsSorted + i,
                                title: allowedPicks ? `${x} ${itemGame[i].game.name.slice(-1)}` : x,
                                isShowNumber: !allowedPicks,
                                active: false,
                                allowedPicks: itemGame[i].game.config.allowed_picks,
                            }
                        })

                        let item = {
                            id: Math.random().toString(16).slice(2),
                            title: x,
                            listRanDomNumber: listRanDomNumber.sort((a, b) => a.title.localeCompare(b.title)),
                            name,
                            price: itemGame[0].game.price,
                            allowedPicks: allowedPicks,
                            betOptions: betOptions
                        }
                        dataSource.push(item)
                    })
                    dataSource = dataSource.sort((a, b) => {
                        return dataSourceOrder.indexOf(a.title) - dataSourceOrder.indexOf(b.title)
                    })
                    this.dataSource = dataSource

                    // FreeBet (Extra 7 Boost) is only eligible on Extra 7. Extra 6
                    // shares the "extra" grouping, so pick the variant whose number
                    // is 7 specifically — never Extra 6. Skip the grouping screen and
                    // jump straight to the Extra 7 event list.
                    if (this.freebetActive) {
                        const extraItem = dataSource.find((g) => (g.title || '').toLowerCase() === 'extra')
                        const extra7Variant = extraItem
                            ? (extraItem.listRanDomNumber || []).find((v) => String(v.number) === '7')
                            : null
                        if (extraItem && extra7Variant) {
                            this.onClickGames(extraItem, extra7Variant)
                            return
                        }
                        // Extra 7 not available for this terminal — fall through to the
                        // normal screen instead of forcing the wrong game.
                    }

                    this.loadingPage = false
                    this.isLoadingScreen = false
                }
            } catch (err) {
                this.loadingPage = false
                this.isLoadingScreen = false
                console.log(err, 'err')
            }
        },
        onClickGames(games, itemGame) {
            // FreeBet Extra 7 Boost is locked to exactly 4 numbers — but only for the
            // Extra 7 game itself, never Extra 6 (same "extra" grouping).
            const isExtra7 = (games.title || '').toLowerCase() === 'extra' && String(itemGame.number) === '7'
            const freebet = this.freebetActive && isExtra7
            let dataDetail = {
                title: games.title,
                gameNumber: itemGame.number,
                name: games.name,
                price: games.price,
                numberQp: freebet ? 4 : (games.title === 'turbo' ? 2 : itemGame.number),
                allowedPicks: freebet ? { min: 4, max: 4 } : itemGame.allowedPicks,
                wager: this.WAGER_MIN_ENV,
                betOptions: games.betOptions,
            }
            dataDetail = JSON.stringify(dataDetail)
            localStorage.setItem('game-loto', dataDetail)
            this.$router.push('/loto-events')
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/loto/_index.scss';
</style>
